import React from 'react';
import { Box, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth } from '../context/AuthContext';

interface PermissionGuardProps {
  section: string;
  level?: 'Read' | 'ReadWrite';
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Wrapper che mostra il contenuto solo se l'utente ha il permesso richiesto.
 * Se non ha il permesso, mostra un messaggio "Accesso negato" o il fallback custom.
 */
export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  section,
  level = 'Read',
  children,
  fallback,
}) => {
  const { hasPermission, permissionsLoaded } = useAuth();

  // Attendi caricamento permessi
  if (!permissionsLoaded) return null;

  if (!hasPermission(section, level)) {
    if (fallback) return <>{fallback}</>;
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '50vh', gap: 2 }}>
        <LockIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
        <Typography variant="h6" color="text.secondary">
          Accesso negato
        </Typography>
        <Typography variant="body2" color="text.disabled">
          Non hai i permessi necessari per accedere a questa sezione.
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default PermissionGuard;
